
<template>
  <div class="obody">
    <div class="tab">
      <div
        class="tabOpt"
        :class="{ act: val == it.value }"
        v-for="(it, index) in list"
        :key="index"
        @click="
          $emit('update:val', it.value);
          fun();
        "
      >
        <span>{{ it.name }}</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      default: [],
      type: Array,
    },
    val: {
      default: "0",
      type: String,
    },
    fun: {
      default: () => {},
      type: Function,
    },
  },
  data() {
    return {
      act: 0,
    };
  },
  components: {},
  computed: {},
  created() {
    this.$emit("update:val", this.list[0].value);
  },
  methods: {},
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";
.obody {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #edeff4;
  margin-bottom: 16px;
  background: #f8f8f8;
}
.tab {
  display: flex;

  align-items: center;

  .tabOpt {
    height: 50px;
    min-width: 160px;
    padding: 0 30px;
    font-size: 18px;
    line-height: 50px;
    margin-bottom: -2px;
    box-sizing: border-box;
    text-align: center;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
    cursor: pointer;
    &.act {
      color: #b4272d;
      border-top: solid 2px #b4272d;
      border-left: solid 1px #edeff4;
      border-right: solid 1px #edeff4;
      border-bottom: solid 2px #f8f8f8;
      background-color: #f8f8f8;
    }
  }
}
</style>